import { getTotalPriceStr, isDev, getPartnerName } from ".";

export const isDeliverConditionFullfilled = (
  order,
  minDeliverTotal,
  busyHour
) => {
  const isMinTotal = getTotalPriceStr(order) > minDeliverTotal;
  const date = new Date();
  const isNotBusyTime = busyHour
    ? date.getHours() < busyHour[0] || date.getHours() > busyHour[1]
    : true;
  if (isDev) console.log({ minDeliverTotal, isMinTotal, isNotBusyTime });
  if (isDev) return true;
  if (isMinTotal && isNotBusyTime) return true;
  return false;
};

export function getDeliverCost(distance, freeDistance) {
  const result = {
    isFree: true,
    cost: 0,
    distance: (distance / 1000).toFixed(1),
  };
  if (!distance) return result;
  const partnerName = getPartnerName().toLowerCase();
  switch (partnerName) {
    case "taumi":
      result.isFree = false;
      result.cost = Math.floor(
        5 + Math.max((distance - freeDistance) / 1000, 0)
      );
      break;
    case "komari":
      if (distance > freeDistance) {
        result.isFree = false;
        result.cost = 5;
      }
      break;
    default:
      throw new Error(`Unknown partnerName: ${partnerName}`);
  }
  if (isDev) console.log({ distance, freeDistance, result });
  return result;
}
